var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_17779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3876 8.99378C15.9565 8.8901 15.5847 8.79977 15.213 8.7118C14.2156 8.47458 13.2206 8.22873 12.2193 8.00958C11.9686 7.9546 11.9788 7.86662 12.1092 7.71581C12.2943 7.50138 12.4919 7.29715 12.684 7.08821C12.7902 6.97275 12.7817 6.86435 12.6684 6.75674C12.2927 6.39857 11.9202 6.03725 11.5445 5.67907C11.147 5.29968 10.7416 4.92815 10.3519 4.5417C10.2168 4.40738 10.1418 4.37989 9.99185 4.5362C9.06243 5.50234 8.11584 6.45119 7.18642 7.41733C6.99976 7.61134 6.9076 7.62627 6.69672 7.42126C5.58611 6.34044 4.4505 5.28633 3.32427 4.22122C2.43547 3.37998 1.55135 2.5348 0.660989 1.69748C0.468076 1.51604 0.430587 1.37622 0.647711 1.17278C1.00386 0.838957 1.33423 0.476851 1.66929 0.12103C1.80206 -0.0203557 1.90437 -0.0509893 2.06448 0.100608C3.01967 1.01098 3.98501 1.91035 4.94333 2.81679C5.533 3.37448 6.12267 3.93374 6.69984 4.50399C6.84824 4.65009 6.94509 4.64145 7.07552 4.50242C7.53632 4.01464 7.99946 3.52765 8.46573 3.04536C8.96793 2.52695 9.47559 2.01482 9.97857 1.49719C10.0778 1.39507 10.166 1.43042 10.2402 1.51133C10.7549 2.07294 11.3618 2.53637 11.8858 3.09092C12.3724 3.60619 12.916 4.0657 13.4346 4.54955C13.6767 4.77577 13.9235 4.99649 14.157 5.23135C14.2843 5.35938 14.3726 5.38059 14.4991 5.22585C14.6655 5.02162 14.8521 4.83232 15.0404 4.64695C15.1778 4.51185 15.2716 4.48279 15.3403 4.73492C15.6004 5.68928 15.8886 6.63578 16.1611 7.58621C16.2752 7.98287 16.3814 8.38268 16.4806 8.78327C16.5079 8.89246 16.5227 9.0307 16.3861 8.99378H16.3876Z",
    fill: "#FF4726"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_17779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.eba8d6da6e983530450bd12d2961b888.svg";
export { ForwardRef as ReactComponent };